<template>
  <v-theme-provider light>
    <v-container
      fluid
      class="section-hears-summary grey lighten-4 grey--text text--darken-3"
      light
      id="section-hears-summary"
      >
        <v-row class="text-center mt-10" align="center">
          <v-col md="10" offset="1">
            <p class="font-weight-medium display-2 grey--text text--darken-3">
              <v-icon class="blink" color="primary">mdi-color-helper</v-icon>Extended, correlated and qualified vulnerability watch platform
            </p>
            <p class="headline grey--text text--darken-3">
              Access a comprehensive and continuously updated vulnerability database scored and enriched with exploit and threat news information. Metadata are collected and qualified by security experts from public OSINT and private feeds
            </p>
          </v-col>
        </v-row>
        <v-row class="my-10 py-10">
          <v-col
            v-for="(n, index) in numbers"
            :key="index"
            cols="12"
            md="4"
            align="center"
            justify="center"
          >
            <v-card
              tile
              elevation="9"
              min-height="120"
              width="90%"
              class="fill-height"
            >
              <v-card-title class="display-1 font-weight-black justify-center mb-2">{{n.value}}</v-card-title>
              <v-card-subtitle class="headline">{{n.details}}</v-card-subtitle>

            </v-card>
          </v-col>
        </v-row>
        <v-row class="my-10 py-10" align="center" justify="center">
          <v-col offset="1">
            <span class="display-2 font-weight-black row-herotext">Monitor your assets with enriched data</span>
            <p class="title mt-5 mb-12">
              Security Teams faces the overall growing number of technologies and assets to monitor, vulnerabilities and attacks growth, talent shortage and cost optimization challenges. PatrowlHears provides a unified source of vulnerability, exploit and threat Intelligence feeds.
            </p>
          </v-col>
          <v-col align="end">
            <v-img max-width="635" :src="hears_img_vuln" class="my-10"></v-img>
          </v-col>
        </v-row>

        <v-row class="my-10 py-10" align="center" justify="center">
          <v-col align="center">
            <v-img max-width="635" :src="hears_img_home" class="my-10"></v-img>
          </v-col>
          <v-col class="mr-10">
            <span class="display-2 font-weight-black row-herotext">Accelerate vulnerability tracking, analysis and remediation</span>
            <p class="title mt-5 mb-12">
              With hundreds of vulnerabilities with critical or high severity to deal with, the daily security reports look like a shining Christmas tree.
              Prioritize your threat management process with a easy and updated access to exposure and <span class="font-weight-bold primary--text">contextualized intelligence</span>:
              <ul class="questions">
                <li>Is a reliable exploit for this vulnerability?</li>
                <li>Are there any likelihood catalysts: Exploited in the Wild? Media hypeness? Exploited by relevant threat actors?</li>
                <li>Is there any known fix or compensation measures?</li>
                <li>Is the vulnerability exploitable from Internet?</li>
                <li>Are we vulnerable or already under-attack??</li>
              </ul>
            </p>
          </v-col>
        </v-row>

        <v-row class="my-5 py-5" align="center" justify="center">
          <v-col offset="1">
            <span class="display-2 font-weight-black row-herotext">Risk-based Scoring</span>
            <p class="title mt-5 mb-12">
              <span class="font-weight-bold primary--text">Prioritization</span> is an essential success factor for improving efficiency and continue to provide the highest quality and relevant service in security incident response and vulnerability management.<br/>
              Our scoring algorithm is <strike>IA-powered, with a lot of Machine Learning tricks</strike> based on relevant metrics from intrinsic vulnerability characteristics, threat topicality and your <span class="font-weight-bold primary--text">asset context</span> as exposure, distribution and criticality.
              <!-- Depending on your vulnerability management decision tree, you empower security team for an immediate correction or put the vulnerability on monitoring until the next patching campaign. -->
            </p>
          </v-col>
          <v-col align="end">
            <v-img max-width="635" :src="hears_img_scoring" class="my-10"></v-img>
          </v-col>
        </v-row>

    </v-container>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecProductSummaryHears",
  data: () => ({
    hears_img_vuln: require('@/assets/screenshots/patrowlhears/patrowlhears-hero-vuln.png'),
    hears_img_home: require('@/assets/screenshots/patrowlhears/patrowlhears-hero.png'),
    hears_img_scoring: require('@/assets/screenshots/patrowlhears/patrowlhears-hero-scoring.png'),
    numbers: [
      { value: '180,000+', details: 'Vulnerabilities' },
      { value: '115,000+', details: 'Vendors, Products, packages and Libraries' },
      { value: '125,000+', details: 'Exploits & Threat Metadata' },
    ]
  }),
};
</script>
<style scoped>
ul.questions {
  list-style-type: square;
}
li::marker {
  color: #f57c00;
}

</style>
